// Authentication Routes
export const AUTH_ROUTES = {
  SIGN_IN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  LOGOUT: "/logout",
  WELCOME_BACK: "/welcomeback",
} as const;

// Query param key identifying which sign-in flow the user came from
export const AUTH_QUERY_PARAMS = {
  FROM: "from",
} as const;

// Values for the AUTH_QUERY_PARAMS.FROM param
export const AUTH_SOURCES = {
  LAWYER: "lawyer",
} as const;

// Public Routes
export const PUBLIC_ROUTES = {
  HOME: "/",
  MOBILE_UPLOAD: "/mobile-upload",
  DOCUMENT_REQUEST: "/document-request",
} as const;

// Onboarding Routes
export const ONBOARDING_ROUTES = {
  ACCOUNT: "/onboarding/account",
} as const;

// Post Loss Routes
export const POST_LOSS_ROUTES = {
  OVERVIEW: "/home",
  DOCUMENTS: "/documents",
  CONTACTS: "/contacts",
  RESOURCES: "/community-and-resources",
  RESOURCES_ARTICLE: "/community-and-resources/:slug",
  SETTINGS: "/settings",
  ESTATE_INVENTORY: "/assets-and-debts",
  ESTATE_ESSENTIALS: "/important-todos",
  ESTATE_ESSENTIALS_MODULE: "/important-todos/:moduleId",
  MODULE: "/:moduleId",

  GET_AUTHORIZED: "/get-authorized",
  IMPORTANT_TODOS: "/important-todos",
  FIND_ASSETS: "/find-assets",
  SETTLE_ESTATE: "/settle-estate",
  SUMMARY: "/summary",
  UPGRADE: "/upgrade",
} as const;

export const UPGRADE_SEARCH_PARAM = "upgrade";

// Admin Routes
export const ADMIN_ROUTES = {
  LAWYERS: "/admin/lawyers",
  LAWYER_DETAIL: "/admin/lawyer/:lawyerId",
  PIXEL_CONTENT: "/admin/pixel-content",
  FEATURE_FLAGS: "/admin/feature-flags",
  // Style Guide
  STYLE_GUIDE: "/admin/style-guide",
  STYLE_GUIDE_FOUNDATION: "/admin/style-guide/foundation",
  STYLE_GUIDE_FORM_CONTROLS: "/admin/style-guide/form-controls",
  STYLE_GUIDE_DATA_DISPLAY: "/admin/style-guide/data-display",
  STYLE_GUIDE_FEEDBACK: "/admin/style-guide/feedback",
  STYLE_GUIDE_LAYOUT: "/admin/style-guide/layout",
  STYLE_GUIDE_OVERLAYS: "/admin/style-guide/overlays",
  STYLE_GUIDE_CUSTOM: "/admin/style-guide/custom",
  STYLE_GUIDE_UPLOAD: "/admin/style-guide/upload",
  STYLE_GUIDE_AUTH: "/admin/style-guide/auth",
  STYLE_GUIDE_INTEGRATIONS: "/admin/style-guide/integrations",
} as const;

// Legal Routes
export const LEGAL_ROUTES = {
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_OF_SERVICE: "/terms-of-service",
} as const;

// Family Routes
export const FAMILY_ROUTES = {
  ACCEPT_INVITATION: "/accept-invitation",
  CLIENT_INVITE: "/client-invite",
  CLIENT_INVITE_SIGNUP: "/client-invite/signup",
} as const;

// General Paths
export const GENERAL_PATHS = {
  POST_LOSS_BASE: "/post-loss",
  USER_SETTINGS: "/user/settings",
} as const;

// Lawyer Routes
export const LAWYER_ROUTES = {
  SIGNUP: "/lawyer/signup",
  SIGNUP_VERIFY: "/lawyer/signup/verify",
  SIGNUP_PROFILE: "/lawyer/signup/profile",
  LOGIN: "/lawyer/login",
  DASHBOARD: "/lawyer/dashboard",
  CLIENT_DETAIL: "/lawyer/client/:userId",
  SETTINGS: "/lawyer/settings",
} as const;

// Demo Routes
export const DEMO_ROUTES = {
  LAWYER: "/demo/lawyer",
  LAWYER_CLIENT: "/demo/lawyer/client",
} as const;
